module.exports = __webpack_public_path__ + "img/cloud1.1644517f.png";